/**
 * `order` (SDD-017 §5.1) ↔ a grid's sort model. `-validFrom,code` is "validFrom descending, then
 * code". The service appends the collection's tie-breaker itself, so the console never sends it.
 *
 * The shape `{ field, sort }` is the MUI Data Grid's `GridSortItem`, restated here because core
 * imports no UI library (backbone §1).
 */

export interface SortItem {
  readonly field: string;
  readonly sort: 'asc' | 'desc' | null | undefined;
}

/** `-validFrom,code` → `[{validFrom, desc}, {code, asc}]`. A blank order is no sort. */
export function parseOrder(order: string | undefined): SortItem[] {
  return (order ?? '')
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part !== '' && part !== '-')
    .map((part) =>
      part.startsWith('-') ? { field: part.slice(1), sort: 'desc' } : { field: part, sort: 'asc' },
    );
}

/** The inverse: a sort model as `order`; items without a direction are dropped. */
export function renderOrder(model: readonly SortItem[]): string {
  return model
    .filter((item) => item.sort === 'asc' || item.sort === 'desc')
    .map((item) => (item.sort === 'desc' ? `-${item.field}` : item.field))
    .join(',');
}
